import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';

// Дизайн-токены @frm/ui импортируются ДО локального workbench-слоя.
// Launcher.css содержит только product-specific слой поверх токенов пакета.
import '@frm/ui/tokens.css';
import './styles/launcher.css';

import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, err) => {
        // Не ретраим 401 — пусть AuthGuard разруливает.
        if (err instanceof Error && err.message === 'UNAUTHENTICATED') return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
